module.exports = __webpack_public_path__ + "img/matic.30254cc.png";